'use strict';

import store, { dispatch, getAppState } from '../../../app/store/configureStore';
import { SegmentInAppNotificationEvent, segmentTrackAction } from "../../middlewares/segment";

import template from './template/notification-group.html';
import { getActiveBoardLngs } from '../../store/model/selectors/getActiveBoardLngs';
import { ECardRoutePrefixes } from "app/store/router/constants";
import {
    getCurrentNavigationPanelType
} from "../react_components/main/navigationPanel/helpers/getCurrentNavigationPanelType";
import { ENavigationPanelTypes } from "../react_components/main/navigationPanel/constants";
import {
    panelTypeSetAction
} from "../react_components/main/navigationPanel/store/navigationPanel/actions/panelTypeSetAction";
import {
    isOpenSetAction
} from "../react_components/main/navigationPanel/store/navigationPanel/actions/isOpenSetAction";
import {
    getUserStarredNotificationsGrouped
} from "../../store/model/authUser/selectors/getUserStarredNotificationsGrouped";
import { setActiveNotification } from "app/view/react_components/notifications/helpers/setActiveNotification";
import { setRecentNotification } from "app/view/react_components/notifications/helpers/setRecentNotification";
import { getAsidePanel } from "app/view/react_components/aside_panel/asidePanel/store/selectors/getAsidePanel";
import { cardsRestPatch } from "../../rest/effects/card/card/api/helper/cardsRestPatch";
import { pushNotificationSet } from "../../rest/effects/pushNotificationSettings/pushNotificationSet";
import { getPushNotificationSettingsByBoardId } from "../../store/model/selectors/getPushNotificationSettingsByBoardId";
import {
    EPushNotificationSettingsScope,
    EPushNotificationSettingsTypes
} from "../../types/rest/IRestPushNotificationSettings";
import { getAuthUser } from "../../store/model/authUser/selectors/getAuthUser";
import { pushNotificationSetEnabled } from "../../rest/effects/pushNotificationSettings/pushNotificationSetEnabled";
import { fetchHandler } from "../../util/fetchHandler";
import { Util } from "../../util/util";
import { REST_BOARD, REST_PUSH_NOTIFICATIONS_SETTINGS } from "../../rest/constants";
import { getRestHeadersGet } from "../../rest/helpers/getRestHeadersHelper";
import { getActiveBoardId } from "../../store/model/selectors/getActiveBoardId";
import { getCard } from "../../store/model/selectors/getCard";
import { cardsGetRest } from "../../rest/effects/card/card/api/helper/cardsGetRest";
import { SegmentNotificationOption } from "../../middlewares/segment/trackEntities/inAppNotificationEvents";
import { snackbarInfoDefault } from "../react_components/snackbarsStack";
import { getMessages } from "../../store/constants";
import { openBoardSettings } from "../react_components/base/effects/openBoardSettings";
import {
    EBoardSetting
} from "../react_components/aside_panel/boardDetails/details/TabDetails/components/TabDetails/types";
import { SegmentBoardSettingsSourceValue } from "../../middlewares/segment/trackEntities/boardEvents";
import { scrollPanelToSection } from "../react_components/aside_panel/asidePanel/helpers/scrollPanelToSection";
import { CLASS_BOARD_DETAILS_SECTION } from "../react_components/aside_panel/boardDetails/constants";

App.Views.NotificationGroup = App.Views.BaseView.extend({
    className: 'notification-group notification-group--one',

    events: {
        'click .js-notification-group__show': 'onShow',
        'click .js-notification-group__hide': 'onHide',
        'click .js-notification-group__read': 'onRead',
        'click .js-notification-group__star': 'onStar',
        'click .js-notification__star': 'onUnstar',
        'click .js-notification-group__read-auto': 'readGroup',
        'click .js-notification__card': 'onCardOpen',
        'click .js-notification-group__click': 'onClick',
        'click .js-notification-group__actions': 'onToggleActions',
        'click .js-notification-group__actions-action--card': 'onToggleCard',
        'click .js-notification-group__actions-action--board': 'onToggleBoard',
        'click .js-notification-group__actions-action--event': 'onToggleEvent',
    },

    initialize: function (options) {
        var lngs = getActiveBoardLngs(getAppState());
        this.template = App.MLTemplate.getTemplate('#notification-group', lngs, template);
        this.model = options.model.getNotificationModel(0);
        this.nofiticationItem = options.model;
        this.notifyInformer = options.notifyInformer;
        this.staredNotifyHelper = options.staredNotifyHelper;
        if (options.isOpened) { // открывать группу при перерендере после загрузки новых нотификаций
            this.$el.addClass('notification-group--opened');
        }
        if (this.nofiticationItem.getNotificationId() === getAppState().notifications.recentNotification) {
            this.$el.addClass('notification-group--recent')
        }
        if (this.nofiticationItem.getNotificationId() === getAppState().notifications.activeNotification) {
            this.$el.addClass('notification-group--active')
        }
        this.onSetActions();
    },

    onShow: function() {
        // var opened = this.$el.closest('.notification-list').find('.notification-group--opened');
        // if (opened.length) { // аккордеон
        //     opened.removeClass('notification-group--opened');
        //     this.scrollTo();
        // }
        this.$el.addClass('notification-group--opened');
        this.mergeGroups();
        App.controller.trackEvent(
            Messages.getText('ga.category.notifications'),
            Messages.getText('ga.action.notifications.group_opened')
        );
        dispatch(segmentTrackAction(SegmentInAppNotificationEvent.CLICKED_SHOW_MORE_ON_NOTIFICATIONS_GROUP, {
                name: this.model.modelType,
                value: this.model.propertyName
            }
        ));
    },

    onHide: function() {
        this.scrollTo();
        App.controller.trackEvent(
            Messages.getText('ga.category.notifications'),
            Messages.getText('ga.action.notifications.group_closed')
        );
        dispatch(segmentTrackAction(SegmentInAppNotificationEvent.CLICKED_SHOW_LESS_ON_NOTIFICATIONS_GROUP, {
                name: this.model.modelType,
                value: this.model.propertyName
            }
        ));
    },

    onRead: function() {
        this.readGroup();
        App.controller.trackEvent(
            Messages.getText('ga.category.notifications'),
            Messages.getText('ga.action.notifications.group_read')
        );
        this.$el.remove();
        dispatch(segmentTrackAction(SegmentInAppNotificationEvent.CLICKED_MARK_ALL_AS_READ, {
                name: this.model.modelType,
                value: this.model.propertyName
            }
        ));
    },

    onStar: function() {
        this.starGroup();
    },

    onUnstar: function() {
        this.starGroup(true);
    },

    onCardOpen: function(e) {
        const boardId = this.model.dashboardId;
        const activeBoardId = getActiveBoardId(getAppState());
        if (activeBoardId === boardId) {
            App.controller.cleverOpenCard(boardId, this.model.modelId);
        } else {
            App.router.navigate(App.router.getAssignedToMePanelUrl(ECardRoutePrefixes.notification, this.nofiticationItem.getNotificationId()), { trigger: true });
        }
        const navigationPanelType = getCurrentNavigationPanelType(getAppState());
        if (navigationPanelType === ENavigationPanelTypes.NP_COMPACT_TYPE) {
            dispatch(panelTypeSetAction(ENavigationPanelTypes.NP_COMPACT_BIG_TYPE));
            dispatch(isOpenSetAction(false));
        }
        this.setGroupSeen();
        e.stopPropagation();
        dispatch(segmentTrackAction(SegmentInAppNotificationEvent.CLICKED_NOTIFICATION, {
                name: this.model.modelType,
                value: this.model.propertyName
            }
        ));
        this.onClick();
    },

    onClick: function() {
        setTimeout(() => {
            const activePlate = store.getState().notifications.activeNotification;
            const isAsidePanelOpened = !!getAsidePanel(store.getState()).width;
            if (this.nofiticationItem.getNotificationId()  === activePlate || !isAsidePanelOpened) return;
            dispatch(setRecentNotification(activePlate));
            dispatch(setActiveNotification(this.nofiticationItem.getNotificationId()));
            this.$el.addClass('notification-group--active');
        })
    },

    getPushNotificationTypeOrScope() {
        const state = getAppState();
        const property = this.model.propertyName;
        const mentions = this.model.mentions;
        if (property === 'name') {
            return EPushNotificationSettingsTypes.NAME_CHANGED;
        } else if (property === 'description') {
            return EPushNotificationSettingsTypes.DESC_CHANGED;
        } else if (property === 'assignees') {
            return EPushNotificationSettingsTypes.USER_ASSIGNED;
        } else if (property === 'priority') {
            return EPushNotificationSettingsTypes.PRIORITY_CHANGED;
        } else if (property === 'comment') {
            return EPushNotificationSettingsTypes.COMMENT_ADDED;
        } else if (property === 'driveDoc') {
            return EPushNotificationSettingsTypes.ATTACH_ADDED;
        } else if (property === 'delete') {
            return EPushNotificationSettingsTypes.DELETED;
        } else if (['archive', 'restore'].includes(property)) {
            return EPushNotificationSettingsTypes.ARCHIVED;
        } else if (['done'].includes(property)) {
            return EPushNotificationSettingsTypes.DONE;
        } else if (['move', 'list'].includes(property)) {
            return EPushNotificationSettingsTypes.LIST_CHANGE;
        } else if (['checkLitsItemDatePassed', 'notificationBeforeDueDate', 'dueDatePassed'].includes(property)) {
            return EPushNotificationSettingsTypes.OVERDUE;
        } else if (property === 'commentReacted') {
            return EPushNotificationSettingsScope.LIKE_MY_COMMENT;
        } else if (['create', 'copy', 'copyFromTemplate', 'copyFromRecurring'].includes(property)) {
            return EPushNotificationSettingsScope.CARD_CREATE;
        } else if (property === 'comment' && mentions.includes(getAuthUser(state).permissionId)) {
            return EPushNotificationSettingsScope.MENTION;
        } else if (property === 'assignedTo') {
            return EPushNotificationSettingsScope.ASSIGN_TO_ME;
        }
    },

    onSetActions() {
        if (this.notifyInformer.readFilterActive) {
            this.$el.toggleClass('notification-group--w-actions', false);
            return;
        }
        const state = getAppState();
        const boardId = this.model.dashboardId;
        const isBoardLoaded = state.model.dashboards[boardId];
        const pushNotificationSettings = getPushNotificationSettingsByBoardId(state, boardId);
        const promise = isBoardLoaded && pushNotificationSettings !== undefined
            ? Promise.resolve(pushNotificationSettings)
            : fetchHandler(Util.getApiUrl(REST_BOARD + boardId + REST_PUSH_NOTIFICATIONS_SETTINGS), {
                    ...getRestHeadersGet()
                }
            );

        promise.then((pushNotification) => {
            const $dropdown = this.$el.find('.notification-group__actions-dropdown');
            $dropdown.children().remove();
            const isEnabled = pushNotification && pushNotification.enabled;
            const className = 'notification-group__actions-action js-notification-group__actions-action';
            if (!isEnabled) {
                this.$el.toggleClass('notification-group--w-actions', true);
                const $boardButton = $(`<button class="${className}--board">Subscribe to notifications about this board</button>`);
                $dropdown.append($boardButton);
            } else {
                const cardId = this.model.modelId;
                const card = getCard(state, cardId);
                const promise = card
                    ? Promise.resolve(card)
                    : dispatch(cardsGetRest([cardId]));
                promise.then(card => {
                    this.$el.toggleClass('notification-group--w-actions', true);
                    const scopes = pushNotification && pushNotification.scope ? pushNotification.scope : [];
                    const isAllCardsWatched = scopes.includes(EPushNotificationSettingsScope.ALL);
                    const $cardButton = $(`<button class="${className}--card">${card && card.wtch || isAllCardsWatched ? 'Unsubscribe from notifications about this card' : 'Subscribe to notifications about this card'}</button>`);
                    $dropdown.append($cardButton);
                    const $boardButton = $(`<button class="${className}--board">Unsubscribe from notifications about this board</button>`);
                    $dropdown.append($boardButton);
                    const typeOrScope = this.getPushNotificationTypeOrScope();
                    const isEnabled = [...(pushNotification.types || []), ...(pushNotification.scope || [])].includes(typeOrScope);
                    const $eventButton = $(`<button class="${className}--event">${isEnabled ? 'Unsubscribe from this type of notifications on this board' : 'Subscribe to this type of notifications on this board'}</button>`);
                    $dropdown.append($eventButton);
                });
            }
        });
    },

    onToggleActions() {
        this.onSetActions();
        this.$el.find('.notification-group__actions').toggleClass('notification-group__actions--opened');
        if (this.$el.find('.notification-group__actions').hasClass('notification-group__actions--opened')) {
            const $dropdown = this.$el.find('.notification-group__actions-dropdown');
            $dropdown.trigger('focus');
            const onBlur = (e) => {
                if (
                    e.relatedTarget &&
                    e.relatedTarget.closest('.notification-group__actions') &&
                    e.relatedTarget.closest('.notification-group__actions') === this.$el.find('.notification-group__actions')[0]
                ) {
                    $dropdown.off('blur', onBlur);
                    return;
                }
                this.$el.find('.notification-group__actions').toggleClass('notification-group__actions--opened');
                $dropdown.off('blur', onBlur);
            };
            $dropdown.on('blur', onBlur);
        }
    },

    onToggleCard: function() {
        const state = getAppState();
        const cardId = this.model.modelId;
        const boardId = this.model.dashboardId;
        const isBoardLoaded = state.model.dashboards[boardId];
        const pushNotificationSettings = getPushNotificationSettingsByBoardId(state, boardId);
        const promise = isBoardLoaded && pushNotificationSettings !== undefined
            ? Promise.resolve(pushNotificationSettings)
            : fetchHandler(Util.getApiUrl(REST_BOARD + boardId + REST_PUSH_NOTIFICATIONS_SETTINGS), {
                    ...getRestHeadersGet()
                }
            );
        promise.then((pushNotification) => {
            const scopes = pushNotification && pushNotification.scope ? pushNotification.scope : [];
            const isAllCardsWatched = scopes.includes(EPushNotificationSettingsScope.ALL);
            if (isAllCardsWatched) {
                dispatch(segmentTrackAction(SegmentInAppNotificationEvent.UNSUCCESSFUL_UNSUBSCRIBE_CARD));
                const linkClass = 'notification-group__actions-action-link';
                dispatch(snackbarInfoDefault({
                    id: 'UNSUCCESSFUL_UNSUBSCRIBE_CARD',
                    text: `${getMessages().getText('card_form_watch_card_change_settings_tooltip')}<a class="${linkClass}" onClick="return onLinkClick()">${getMessages().getText('card_form_watch_card_change_settings_tooltip_link')}</a>`,
                }));
                setTimeout(() => {
                    const link = document.querySelector('.' + linkClass);
                    if (link) {
                        link.addEventListener('click', () => {
                            dispatch(openBoardSettings(EBoardSetting.APP_NOTIFICATIONS, SegmentBoardSettingsSourceValue.CARD_WATCH_SETTINGS));
                            //wait until board settings are opened
                            setTimeout(() => {
                                scrollPanelToSection(
                                    `.${CLASS_BOARD_DETAILS_SECTION}--notifications`,
                                    null,
                                    {current: null});
                                setTimeout(() => {
                                    const className = 'board-details__push-notifications-item';
                                    const item = document.querySelector('.' + className + '--watch');
                                    if (item) {
                                        item.classList.add(className + '--blink');
                                    }
                                }, 300);
                            }, 0);
                        });
                    }
                })
            } else {
                const card = getCard(state, cardId);
                if (card) {
                    const wtch = !card.wtch;
                    if (wtch) {
                        dispatch(segmentTrackAction(SegmentInAppNotificationEvent.SUBSCRIBE_CARD_CLICK));
                    } else {
                        dispatch(segmentTrackAction(SegmentInAppNotificationEvent.UNSUBSCRIBE_CARD_CLICK));
                    }
                    const cards = { [cardId]: { wtch }};
                    dispatch(cardsRestPatch(cards));
                }
            }
        });
        this.onToggleActions();
    },

    onToggleBoard: function() {
        const state = getAppState();
        const boardId = this.model.dashboardId;
        const pushNotification = getPushNotificationSettingsByBoardId(state, boardId);
        const isEnabled = !pushNotification || !pushNotification.enabled;
        if (isEnabled) {
            dispatch(segmentTrackAction(SegmentInAppNotificationEvent.SUBSCRIBE_BOARD_CLICK));
        } else {
            dispatch(segmentTrackAction(SegmentInAppNotificationEvent.UNSUBSCRIBE_BOARD_CLICK));
        }
        dispatch(pushNotificationSetEnabled(boardId, isEnabled));
        this.onToggleActions();
    },

    onToggleEvent: function() {
        this.onToggleActions();
        const state = getAppState();
        const boardId = this.model.dashboardId;
        const isBoardLoaded = state.model.dashboards[boardId];
        const promise = isBoardLoaded
            ? Promise.resolve().then(() => getPushNotificationSettingsByBoardId(state, boardId))
            : fetchHandler(Util.getApiUrl(REST_BOARD + boardId + REST_PUSH_NOTIFICATIONS_SETTINGS), {
                ...getRestHeadersGet()
            }
        );
        promise.then((pushNotification) => {
            const types = pushNotification.types || [];
            const subscribeCases = pushNotification.subscribeCases;
            const scope = pushNotification.scope || [];
            const onSendEvent = (type, isSubscribe) => {
                const option = {
                    name: SegmentNotificationOption.TYPE,
                    value: type,
                };
                if (isSubscribe) {
                    dispatch(segmentTrackAction(SegmentInAppNotificationEvent.SUBSCRIBE_EVENT_CLICK, option));
                } else {
                    dispatch(segmentTrackAction(SegmentInAppNotificationEvent.UNSUBSCRIBE_EVENT_CLICK, option));
                }
            }
            const onToggleType = (item) => {
                let newTypes = [...types];
                const isSubscribe = !types.includes(item);
                if (isSubscribe) {
                    newTypes.push(item);
                } else {
                    newTypes = newTypes.filter(type => type !== item);
                }
                onSendEvent(item, isSubscribe);
                dispatch(pushNotificationSet(
                    boardId,
                    scope,
                    subscribeCases,
                    newTypes,
                ));
            };
            const onToggleScope = (item) => {
                let newScope = [...types];
                const isSubscribe = !scope.includes(item);
                if (isSubscribe) {
                    newScope.push(item);
                } else {
                    newScope = newScope.filter(type => type !== item);
                }
                onSendEvent(item, isSubscribe);
                dispatch(pushNotificationSet(
                    boardId,
                    newScope,
                    subscribeCases,
                    types
                ));
            };
            const typeOrScope = this.getPushNotificationTypeOrScope();
            if (Object.values(EPushNotificationSettingsTypes).includes(typeOrScope)) {
                onToggleType(typeOrScope);
            } else {
                onToggleScope(typeOrScope);
            }
        });
    },

    readGroup: function() {
        this.$el.closest('.notifications').focus(); // элемент исчезнет из вкладки unread, перед этим надо перенести фокус, чтоб дропдаун не закрылся
        this.scrollTo();
        this.setGroupSeen();
        this.nofiticationItem.set('rendered', false);
        //this.$el.remove();
    },

    starGroup: function(isSingle) {
        if (document.querySelector('.topbar-notifications__tabs-tab--starred.active') && !isSingle) {
            this.$el.closest('.notifications').focus(); // элемент исчезнет из вкладки starred, перед этим надо перенести фокус, чтоб дропдаун не закрылся
            this.scrollTo();
            this.nofiticationItem.set('rendered', false);
            this.$el.remove();
        }
        this.toggleGroupStarred(isSingle);
    },

    toggleGroupStarred: function(isSingle) {
        const isGrouped = this.notifyInformer.isStarredActive() &&  getUserStarredNotificationsGrouped(getAppState());
        if (!isSingle && isGrouped) {
            const cardId = this.model.modelId;
            this.staredNotifyHelper.unStarredCardNotifications(cardId);
            dispatch(segmentTrackAction(SegmentInAppNotificationEvent.UNSTAR_GROUP));
        } else {
            const starred = this.staredNotifyHelper.isStarredNotification(this.nofiticationItem.getNotificationId());
            if (starred) {
                this.$el.removeClass('notification-group--starred');
                this.staredNotifyHelper.unStarredNotification(this.nofiticationItem);
                this.$el.find('.notification-group__star-tooltip').html(Messages.getText('noty.groups.star'));
                dispatch(segmentTrackAction(SegmentInAppNotificationEvent.UNSTAR_NOTIFICATION));
            } else {
                this.$el.addClass('notification-group--starred');
                this.staredNotifyHelper.starredNotification(this.nofiticationItem);
                this.setGroupSeen();
                this.$el.find('.notification-group__star-tooltip').html(Messages.getText('noty.groups.unstar'));
                this.$el.remove();
                dispatch(segmentTrackAction(SegmentInAppNotificationEvent.STAR_NOTIFICATION));
            }
        }
        this.notifyInformer.updateView();
    },

    setGroupSeen: function() {
        this.$el.find('.notification-list__item--unread').each(function () {
            $(this).data('backbone-view').setSeen(true);
        });
    },

    scrollTo: function() {
        var top = this.$el.position().top;
        if (top < 0) {
            var scroll = this.$el.closest('.dropdown__body').get(0);
            scroll.scrollTop += top - 7;
        }
    },

    mergeGroups: function() {
        var duplicates = $('[data-card="' + this.$el.data('card') + '"]');
        if (duplicates.length < 2) return;
        if (duplicates.index(this.$el) > 0) return;
        var remove = duplicates.not(this.$el);
        remove.find('.notification-list__item').appendTo(this.$el.find('.notification-group__list').first());
        remove.remove();
    },

    getContent: function() {
        var boardName = this.model.dashboardName || null,
            boardIcon = 'board', // todo star
            listName = null,
            cardName = null;
        if (this.model.card) {
            cardName = this.model.card.name;
            listName = this.model.card.listName;
        }
        return {
            boardName: boardName,
            boardIcon: boardIcon,
            listName: listName,
            cardName: cardName,
            showMore: Messages.getText('noty.groups.show_more'),
            less: Messages.getText('noty.groups.less'),
            read: Messages.getText('noty.groups.read'),
            star: this.staredNotifyHelper.isStarredNotification(this.nofiticationItem.getNotificationId()) ? Messages.getText('noty.groups.unstar') : Messages.getText('noty.groups.star'),
        }
    },

    render: function () {
        this.$el.html(this.template(this.getContent()));
        return this;
    }
});
App.Views.NotificationGroup.mixin(App.Mixins.Test);
